import { createSlice } from "@reduxjs/toolkit";
import { getTranslations } from "./thunk";

export const initialState = {
  // getPagedPaymentHistoryReport
  translations: {},
  translationsLoading: false,
  translationsError: false,
};

const TranslationSlice = createSlice({
  name: "translations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTranslations.pending, (state) => {
      state.translationsLoading = true;
      state.translationsError = false;
    });
    builder.addCase(getTranslations.fulfilled, (state, action: any) => {
      state.translationsLoading = false;
      state.translationsError = false;
      state.translations = action.payload;
    });
    builder.addCase(getTranslations.rejected, (state: any, action: any) => {
      state.translationsLoading = false;
      state.translationsError = true;
    });
  },
});

export default TranslationSlice.reducer;
